import { Injectable } from "@angular/core";
import { DwTaskItem, formatDateTimeToLocal, getMomentValue } from "@devwareapps/devware-cap";
import { CheckRideRequestEntity, CheckRideRequestSubStatusAllItems } from "../../../meta-data/app-meta-data.service";
import * as moment from "moment";

@Injectable({
    providedIn: 'root'
})
export class ExaminerTaskService {

    examinerTaskDefinitions: ExaminerTaskDefinition[] = [
        {
            taskType: ExaminerTaskType.todaysCheckrides,
            titleTextSuffix: 'today',
            toolipTextSuffix: ' are booked for today',
            iconClass: 'fa fa-check dw-blue',
            navigateUrlBase: '/bookings',
            bookingTile: 'booked',
            filterDisplay:'Today\'s Checkrides',
            filterFunc: (checkride) => this.isForToday(checkride)
        },
        {
            taskType: ExaminerTaskType.upcomingCheckrides,
            titleTextSuffix: ' this week',
            toolipTextSuffix: ' are booked later this week',
            iconClass: 'fa fa-check dw-green',
            navigateUrlBase: '/bookings',
            bookingTile: 'booked',
            filterDisplay:'Checkrides this week',
            filterFunc: (checkride) => this.isForThisWeek(checkride)
        },
        {
            taskType: ExaminerTaskType.pendingCheckrides,
            titleTextSuffix: '  Pending Approval',
            toolipTextSuffix: '  are waiting for your approval',
            iconClass: 'fa fa-check dw-orange',
            navigateUrlBase: '/bookings',
            bookingTile: '',
            filterDisplay:'Checkrides Pending Approval',
            filterFunc: (checkride) => checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingApproval
        },
        {
            taskType: ExaminerTaskType.pendingRescheduleCheckrides,
            titleTextSuffix: ' Pending Reschedule',
            toolipTextSuffix: '   are waiting to be rescheduled',
            iconClass: 'fa fa-check dw-orange',
            navigateUrlBase: '/bookings',
            bookingTile: '',
            filterDisplay:'Checkrides Pending Reschedule',
            filterFunc: (checkride) => checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingReschedule
        },
        {
            taskType: ExaminerTaskType.pendingOutcomeCheckrides,
            titleTextSuffix: ' Pending Outcome',
            toolipTextSuffix: '  need to have their outcome updated',
            iconClass: 'fa fa-check dw-orange',
            navigateUrlBase: '/bookings',
            bookingTile: 'booked',
            filterDisplay:'Checkrides Pending Outcome',
            filterFunc: (checkride) => checkride.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingOutcome
        }
    ]

    
  public isScheduledCheckride(checkride: CheckRideRequestEntity): boolean {

    switch (checkride.CheckRideRequestSubStatusId) {
      case CheckRideRequestSubStatusAllItems.Cancelled:
      case CheckRideRequestSubStatusAllItems.Completed:
      case CheckRideRequestSubStatusAllItems.Rejected:
      case CheckRideRequestSubStatusAllItems.Deleted:
      case CheckRideRequestSubStatusAllItems.Draft:
      case CheckRideRequestSubStatusAllItems.PendingPayment:

        return false;
    }

    return true;
  }


    getCheckrideTasks(checkrides: CheckRideRequestEntity[], showAllTasks: boolean = false): DwTaskItem[] {
        const tasks: DwTaskItem[] = [];

        for (const taskDefinition of this.examinerTaskDefinitions) {
            const task = this.buildCheckrideTask(checkrides, taskDefinition, showAllTasks);

            if (task) {
                tasks.push(task)
            }
        }

        return tasks;
    }

    buildCheckrideTask(checkrides: CheckRideRequestEntity[], taskDefinition: ExaminerTaskDefinition, showAllTasks: boolean): DwTaskItem {
        const filteredCheckrides = checkrides.filter(checkride => taskDefinition.filterFunc(checkride));

        if (filteredCheckrides.length == 0 && !showAllTasks) {
            return null;
        }

        const checkrideText = this.pluralizeWord('Checkride', 'Checkrides', filteredCheckrides.length);

        let navigateUrl = taskDefinition.navigateUrlBase || '/bookings';

        const urlParams: string[] = [];

        urlParams.push(`filter=${taskDefinition.taskType}`);

        if (taskDefinition.bookingTile) {
            urlParams.push(`tile=${taskDefinition.bookingTile}`);
        }

        navigateUrl += `?${urlParams.join('&')}`;

        const task: DwTaskItem = {
            iconClass: taskDefinition.iconClass,
            taskTitle: `${filteredCheckrides.length} ${checkrideText} ${taskDefinition.titleTextSuffix}`,
            tooltip: `${filteredCheckrides.length} ${checkrideText} ${taskDefinition.toolipTextSuffix}`,
            navigateUrl: navigateUrl
        }

        return task;

    }

    isForToday(checkride: CheckRideRequestEntity): boolean {


        //const scheduleDateTime = getMomentValue(checkride.ScheduledDateTime, true, true);
        const scheduleDateTimeLocal = formatDateTimeToLocal(checkride.ScheduledDateTime, true, true);

        const scheduleDateTime = getMomentValue(scheduleDateTimeLocal, true, true);

        const now = moment();

        if (scheduleDateTime.isSame(now, 'day')) {
            return true;
        }

        return false;
    }

    isForThisWeek(checkride: CheckRideRequestEntity): boolean {
        const scheduleDateTimeLocal = formatDateTimeToLocal(checkride.ScheduledDateTime, true, true);
        const scheduleDateTime = getMomentValue(scheduleDateTimeLocal, true, true);
        const now = moment().add(1, 'days');
        const sat = moment().weekday(6); // 6 is saturday

        if (scheduleDateTime.isSameOrAfter(now, 'day') && scheduleDateTime.isSameOrBefore(sat, 'day')) {
            return true;
        }

        return false;
    }

    private pluralizeWord(word: string, pluralword: string, count: number): string {
        if (count == 1) {
            return word;
        }

        return pluralword;
    }
}


export enum ExaminerTaskType {
    todaysCheckrides = 'todaysCheckrides',
    upcomingCheckrides = 'upcomingCheckrides',
    pendingCheckrides = 'pendingCheckrides',
    pendingRescheduleCheckrides = 'pendingRescheduleCheckrides',
    pendingOutcomeCheckrides = 'pendingOutcomeCheckrides',
}


export interface ExaminerTaskDefinition {
    taskType: ExaminerTaskType;
    titleTextSuffix: string,
    toolipTextSuffix: string,
    iconClass: string;
    navigateUrlBase?: string;
    bookingTile?: string;
    filterFunc: (CheckRideEntity) => boolean;

    filterDisplay: string;
}
